export default __webpack_public_path__ + "static/media/An lanh.5baa932b.png";